import React, { useContext, useState } from 'react';
import { Avatar, Box, Grid, Tooltip, Typography } from '@mui/material';
import { LanguageContext } from '../../../../../../libs/Context';

// Component for rendering avatars
const AvatarSection = (props:any) =>
{
	const { avatarList, selectEvent, requestT, handleRemove,
		downSM, handleAttendees } = props;
	const { language } = useContext(LanguageContext);
	const [ hoveredIndex, setHoveredIndex ] = useState(null);

	const maxVisibleAvatars = downSM ? 3 : 4;
	const extraAvatarsCount = avatarList.length - maxVisibleAvatars;

	return (
		<Grid item xs={12} container spacing={downSM ? 1 : 2} display={'flex'} justifyContent={'center'}>
			{avatarList.slice(0, maxVisibleAvatars).map((avatarUrl:any, index:any) => (
				<Grid item key={avatarUrl?.key} sx={{ width: downSM ? 32 : props.Wspace || 80 }}>
					<Box
						onMouseEnter={() => setHoveredIndex(index)}
						onMouseLeave={() => setHoveredIndex(null)}
						sx={{
							position     : 'relative',
							width        : downSM ? 28 : props.width || 60,
							height       : downSM ? 28 : props.width || 60,
							borderRadius : '50%'
						}}
					>
						<Avatar
							src={avatarUrl?.src}
							sx={{
								width     : '100%',
								height    : '100%',
								border    : '4px solid rgba(255, 255, 255, 1)',
								cursor    : 'pointer',
								boxShadow : 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px'
							}}
						/>
						{hoveredIndex === index && selectEvent && requestT !== 'viewEvent' && (
							<Box
								sx={{
									position       : 'absolute',
									top            : 0,
									left           : 0,
									width          : '100%',
									height         : '100%',
									bgcolor        : 'rgba(0,0,0,0.5)',
									color          : 'white',
									borderRadius   : '50%',
									display        : 'flex',
									justifyContent : 'center',
									alignItems     : 'center',
									fontSize       : '10px',
									cursor         : 'pointer'
								}}
								onClick={() => handleRemove(avatarUrl?.userId)}
							>
								{language?.remove}
							</Box>
						)}
					</Box>
					<Box sx={{ width: '100%', overflow: 'hidden', display: downSM ? 'none' : 'flex', cursor: 'pointer' }}>
						<Tooltip title={avatarUrl?.name}>
							<Typography
								fontSize={14}
								sx={{
									whiteSpace    : 'nowrap',
									overflow      : 'hidden',
									textOverflow  : 'ellipsis',
									textTransform : 'capitalize',
									width         : '100%',
									textAlign     : 'center'
								}}
							>
								{avatarUrl?.name}
							</Typography>
						</Tooltip>

					</Box>
				</Grid>
			))}
			{extraAvatarsCount > 0 && (
				<Grid item>
					<Avatar
						sx={{
							width           : downSM ? 28 : props.width || 60,
							height          : downSM ? 28 : props.width || 60,
							border          : '4px solid rgba(255, 255, 255, 1)',
							borderRadius    : '50%',
							backgroundColor : '#E2F3Ff',
							color           : 'rgba(36, 164, 196, 1)',
							fontWeight      : 500,
							fontSize        : downSM ? 10 : 20,
							cursor          : 'pointer',
							boxShadow       : 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px'
						}}
						onClick={handleAttendees}
					>
						+{extraAvatarsCount}
					</Avatar>
				</Grid>
			)}
		</Grid>
	);
};

export default AvatarSection;